import React from 'react';
import { Dialog } from '@material-ui/core';

const WithDialog =
  (WrappedComponent) =>
  ({ classes, userData, dialogRootClass, withDialog = true, ...otherProps }) => {
    const { theme } = userData.userProfile || {};
    const dialogContent = (
      <div className={`${classes.dialogWrapper} ${theme}`}>
        <WrappedComponent
          {...otherProps}
          classes={classes}
          withDialog={withDialog}
          userData={userData}
        />
      </div>
    );

    return withDialog ? (
      <Dialog
        open
        maxWidth={false}
        scroll={undefined}
        classes={{ root: dialogRootClass ? dialogRootClass : undefined, paper: classes.dialog }}>
        {dialogContent}
      </Dialog>
    ) : (
      dialogContent
    );
  };

export default WithDialog;
